import React from 'react';
import styled from "@emotion/styled";
import servicesPhoto from "../ServicesPhoto.jpg";

const ServicesPageContainer = styled("div")({
    padding: "20px",
  })

export const Services = () => {
    return (
        <ServicesPageContainer className="Services container col-xl-10 col-xxl-8 px-4 py-5" data-bs-theme="dark">
            <div className="row g-lg-5">
            <div className="col-lg-7 py-2">
                <h3 className="display-4 fw-bold lh-1 text-body-emphasis mb-3">TAX SERVICES</h3>
                <p className="fs-6">
                    LTC provides an array of tax services including tax return preparation and filing and a variety of consulting services. With years of experience and knowledge of multiple tax types, LTC is a great resource for your tax needs.
                </p>
                <a className="col-lg-10 fs-6 icon-link link-warning link-underline-warning link-underline-opacity-25 mb-1" href="/Contact">Please contact for a free consultation.</a>
                <br/>
                <br/>
                <br/>
                <br/>
                <h3 className="display-6 fw-bold lh-1 text-body-emphasis mb-3">TAX RETURN PREPARATION & FILING</h3>
                <p className="fs-6">
                Take the stress out of filing your tax returns.
                </p>
                <p className="fs-6">
                LTC has the experience and expertise preparing federal, state and local tax returns for individual and business taxpayers.
                <br/>
                Specific income tax forms prepared include Form 1040, Form 1065, Form 1120/1120S and applicable state and local tax forms.
                <br/>
                Specific tax topics include but are not limited to, rental property taxes, self employment taxes, deceased taxpayer/estate taxes, multi-state tax returns.
                </p>
                <br/>
                <br/>
                <br/>
                <br/>
                <h3 className="display-6 fw-bold lh-1 text-body-emphasis mb-3">CONSULTING SERVICES</h3>
                <p className="fs-6">
                Businesses have an array of tax requirements and rules to adhere to that can become problematic if not addressed.
                </p>
                <p className="fs-6">
                    LTC can help advise and guide you through tax-related issues. Below is a list of consulting services provided.
                </p>
                <ul className="list-group">
                    <li >Business Personal Property Tax Filing and Appeals</li>
                    <li >Business Registrations</li>
                    <li >IRS and State Notice Assistance</li>
                    <li >IRS and State Audit Assistance</li>
                    <li >Sales & Use Tax Planning</li>
                    <li >Sales & Use Tax Return Filing</li>
                    <li >State and Local Audit Assistance</li>
                    <li >Tax Research</li>
                    <li >Voluntary Disclosures</li>
                </ul>
            </div>
            <div className="col-md-10 mx-auto col-lg-5 py-2">
                <img style={{borderRadius: "20px"}} src={servicesPhoto} className="d-block mx-lg-auto img-fluid" alt="Limke Tax Forms By River" loading="lazy"/>
            </div>
        </div>
        </ServicesPageContainer>
    )
}